import React, { Fragment, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import FBannerSpend from "../../components/FspendComponents/FBannerSpend/FBannerSpend";
import FBoxContainer from "../../components/FBoxContainer/FBoxContainer";
import FCategoryContainer from "../../components/FCategoryContainer/FCategoryContainer";
import { AuthContext } from "../../context/AuthContext";
import { getGiftCards } from "../../api/spend";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";

const GiftCardScreen = ({ param }) => {
  const route = useNavigate();

  const { setLoading,checkToken } = useContext(AuthContext);
  const [giftCards, setGiftCards] = React.useState([]);

  const { goToTransactionCustomizationScreen } = useBillPaymentArcus();

  const getGiftCard = async () => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getGiftCards();
      setLoading(false);
      setGiftCards(data.data);
    } catch (e) {
      setLoading(false);
      //console.log(e.response?._response);
    }
  };

  useEffect(() => {
    getGiftCard();
  }, []);

  const action = (item) => {
    goToTransactionCustomizationScreen(item);
  };

  return (
    <>
      <FBannerSpend
        imageUrl={require("../../components/assets/images/credit-card.png")}
        title="Tarjetas de regalo"
        description="Saldo Disponible"
      />

      <div className="mb-16">
        <FBoxContainer sortedCategories={giftCards} action={action} />
      </div>
    </>
  );
};

export default GiftCardScreen;
